export default {
  fragrance: {
    en: 'Fragrance',
  },
  skincare: {
    en: 'Skincare',
  },
  makeup: {
    en: 'Makeup',
  },
  wellness: {
    en: 'Other',
  },
}
